module.exports = __webpack_public_path__ + "img/twi.bca976d2.png";